__turbopack_context__.v({
  "SLocationIcon": "bzbCbG_SLocationIcon",
  "SLocationName": "bzbCbG_SLocationName",
  "SLocationResult": "bzbCbG_SLocationResult",
  "SLocationSvg": "bzbCbG_SLocationSvg",
});
